// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormSuccess_wrapper__38pkv","check-mark":"FormSuccess_check-mark__2BypI"};